import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Check, Loader2 } from "lucide-react";
import { postJson } from "@/lib/auth";
import { useLang } from "@/lib/i18n";

export default function ResetPassword() {
  const { t, lang } = useLang();
  const [params] = useSearchParams();
  const token = params.get("token");
  const [value, setValue] = useState("");
  const [state, setState] = useState("idle");
  const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setState("busy");
    setError("");
    try {
      await postJson(token ? "/members/reset-password" : "/members/forgot-password", token ? { token, password: value } : { email: value, lang });
      setState("done");
    } catch (err) {
      setError(err.message);
      setState("idle");
    }
  };
  return (
    <main className="px-5 pb-28 pt-32 md:px-10" data-testid="reset-page">
      <div className="mx-auto max-w-md">
        <h1 className="font-display text-5xl leading-[0.95]">{token ? t("reset.newTitle") : t("reset.title")}</h1>
        {state === "done" ? (
          <div className="mt-8 rounded-2xl border border-white/10 bg-[var(--card)] p-6" data-testid="reset-done">
            <Check className="text-[var(--green)]" />
            <p className="mt-3 text-sm">{token ? t("reset.doneNew") : t("reset.sent")}</p>
            <Link to="/entrar" className="btn-primary mt-6" data-testid="reset-to-login-btn">{t("auth.login")}</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="reset-form">
            <p className="text-sm text-[var(--muted)]">{token ? t("auth.pwHint") : t("reset.intro")}</p>
            <input type={token ? "password" : "email"} required minLength={token ? 8 : 3} value={value} onChange={(e) => setValue(e.target.value)} placeholder={token ? t("auth.password") : t("form.emailPh")} className="support-input" data-testid="reset-input" />
            {error && <p className="text-sm text-[#ff8a7a]" data-testid="reset-error">{error}</p>}
            <button type="submit" disabled={state === "busy"} className="btn-primary w-full justify-center" data-testid="reset-submit-btn">
              {state === "busy" && <Loader2 size={16} className="animate-spin" />} {token ? t("reset.save") : t("reset.send")}
            </button>
          </form>
        )}
      </div>
    </main>
  );
}
